<template>
	<LayoutDefaultNew>
		<div v-if="isCreateDocumentVisible">
			<CreateDocument :key="refreshKeyCreateDocument" />
		</div>
	</LayoutDefaultNew>
</template>

<script>
// ? components-----------------------------------------------------------------------------------
import { onMounted } from '@vue/composition-api'
import CreateDocument from '@/_srcv2/pages/admin/create-document/CreateDocument.vue'
import useCreateDocumentComponentState from '@/_srcv2/pages/admin/create-document/components/useCreateDocumentComponentsState.js'

export default {
	name: 'CreateCreditInvoiceDispatchOrder',
	components: {
		CreateDocument,
	},
	setup() {
		const { isCreateDocumentVisible, refreshKeyCreateDocument, createLevel } =
			useCreateDocumentComponentState()
		onMounted(() => {
			console.log('CreateCreditInvoiceDispatchOrder is initialized')
			createLevel.value = 4
			refreshKeyCreateDocument.value += 1
			isCreateDocumentVisible.value = false
			setTimeout(() => {
				isCreateDocumentVisible.value = true
			}, 500)
		})
		// todo -----------------------------------------------------------------
		return {
			createLevel,
			isCreateDocumentVisible,
			refreshKeyCreateDocument,
		}
	},
}
</script>

<style lang="scss" scoped></style>
